enum Storage{
    TWO_FACTOR_LIST = 'twoFactorList',
    EMAIL = 'email',
    N_INTENTOS = 'NIntentos',
    LAST_ACCESS = 'lastAcces',
    COMPANY_NAME = 'companyName',
    TOKEN = 'token',
    SUPPORT_LOGIN = 'Support_Login',
    ACCESS_TOKEN = 'access_token',
}

export default Storage;